"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueType = exports.themeKey = exports.textStatusKey = exports.tempStatusKey = exports.styles = exports.statusKey = exports.signalRanges = exports.sensorTypes = exports.secondsAmountInOneMinute = exports.regularsByDisplayNameId = exports.regularByDeviceProductCodeList = exports.paramsByDisplayNameId = exports.packageKey = exports.modelsWithVersion = exports.millisecondsAmountInOneSecond = exports.locales = exports.imgSizeKeys = exports.filterTypes = exports.errorType = exports.errorComponent = exports.defaultTheme = exports.defaultProductDisplayClassification = exports.defaultLocale = exports.colorsPercentRanges = exports.colors = exports.colorStatus = exports.classificationVersionByProductDisplayClass = exports.classificationByProductDisplayClass = exports.branchKeyList = exports.boxShadow = exports.borderRadius = exports.alertTypes = exports.SectionTypes = exports.LoopType = exports.LinkTo = exports.EdgeNodeValueTypes = exports.ComponentTypes = void 0;
const packageKey = exports.packageKey = 'core';
const branchKeyList = exports.branchKeyList = {
  prod: 'prod',
  stg: 'stg',
  dev: 'dev'
};
const statusKey = exports.statusKey = {
  online: 'online',
  offline: 'offline'
};
const themeKey = exports.themeKey = {
  dark: 'dark',
  light: 'light'
};
const defaultTheme = exports.defaultTheme = themeKey.light;
const filterTypes = exports.filterTypes = {
  search: 'search',
  select: 'select',
  button: 'button'
};
const colorsPercentRanges = exports.colorsPercentRanges = {
  excellent: [90, 135],
  good: [60, 90],
  fairToPoor: [30, 60],
  fair: [30, 60],
  poor: [15, 30],
  noSignal: [0, 15]
};
const EdgeNodeValueTypes = exports.EdgeNodeValueTypes = {
  RSSI: '/RSSI',
  RSRP: '/RSRP',
  RSRQ: '/RSRQ',
  SINR: '/SINR'
};
const signalRanges = exports.signalRanges = {
  [EdgeNodeValueTypes.RSRP]: {
    excellent: [-90, Infinity],
    good: [-105, -90],
    fairToPoor: [-120, -105],
    noSignal: [-Infinity, -120]
  },
  [EdgeNodeValueTypes.RSRQ]: {
    excellent: [-10, Infinity],
    good: [-15, -10],
    fairToPoor: [-20, -15],
    noSignal: [-Infinity, -20]
  },
  [EdgeNodeValueTypes.SINR]: {
    excellent: [20, Infinity],
    good: [13, 20],
    fairToPoor: [0, 13],
    noSignal: [-Infinity, 0]
  },
  [EdgeNodeValueTypes.RSSI]: {
    excellent: [-65, Infinity],
    good: [-75, -65],
    fair: [-85, -75],
    poor: [-95, -85],
    noSignal: [-Infinity, -95]
  }
};
const locales = exports.locales = ['en-US', 'de-DE'];
const defaultLocale = exports.defaultLocale = 'de-DE';
const imgSizeKeys = exports.imgSizeKeys = {
  original: 'original',
  preview: 'preview'
};
const tempStatusKey = exports.tempStatusKey = {
  noData: 'noData',
  optimal: 'optimal',
  isLow: 'isLow',
  isHigh: 'isHigh',
  oldData: 'oldData',
  wrongData: 'wrongData'
};
const textStatusKey = exports.textStatusKey = {
  noData: 31,
  optimal: 12,
  isLow: 13,
  isHigh: 14,
  oldData: 32,
  wrongData: 33
};
const colorStatus = exports.colorStatus = {
  noData: 'grey',
  optimal: 'blue',
  isLow: 'red',
  isHigh: 'red',
  oldData: 'grey',
  wrongData: 'red'
};
const sensorTypes = exports.sensorTypes = {
  temperatureSensor: 'temperatureSensor',
  smartValve: 'smartValve',
  energyValve: 'energyValve',
  pump: 'pump',
  mixerValve: 'mixerValve',
  backflushFilter: 'backflushFilter'
};
const defaultProductDisplayClassification = exports.defaultProductDisplayClassification = {
  [sensorTypes.temperatureSensor]: 0,
  [sensorTypes.smartValve]: 1,
  [sensorTypes.energyValve]: 5,
  [sensorTypes.pump]: 4,
  [sensorTypes.mixerValve]: 7,
  [sensorTypes.backflushFilter]: 6
};
const modelsWithVersion = exports.modelsWithVersion = {
  temperatureSensor: sensorTypes.temperatureSensor,
  paulTemperature_v1: 'paulTemperature_v1',
  smartValve_v4_v5: "".concat(sensorTypes.smartValve, "_v4_v5"),
  smartValve_v1_v2_v3: "".concat(sensorTypes.smartValve, "_v1_v2_v3"),
  smartValve_v6: "".concat(sensorTypes.smartValve, "_v6"),
  mixerValve: sensorTypes.mixerValve,
  energyValve: sensorTypes.energyValve,
  pump: sensorTypes.pump,
  backflushFilter: sensorTypes.backflushFilter
};
const classificationVersionByProductDisplayClass = exports.classificationVersionByProductDisplayClass = {
  0: modelsWithVersion.temperatureSensor,
  1: modelsWithVersion.smartValve_v1_v2_v3,
  2: modelsWithVersion.smartValve_v4_v5,
  3: modelsWithVersion.smartValve_v6,
  4: modelsWithVersion.pump,
  5: modelsWithVersion.energyValve,
  6: modelsWithVersion.backflushFilter,
  7: modelsWithVersion.mixerValve,
  8: modelsWithVersion.paulTemperature_v1
};
const classificationByProductDisplayClass = exports.classificationByProductDisplayClass = {
  0: sensorTypes.temperatureSensor,
  1: sensorTypes.smartValve,
  2: sensorTypes.smartValve,
  3: sensorTypes.smartValve,
  4: sensorTypes.pump,
  5: sensorTypes.energyValve,
  6: sensorTypes.backflushFilter,
  7: sensorTypes.mixerValve,
  8: sensorTypes.temperatureSensor
};

/** @deprecated regularByDeviceProductCodeList */
const regularByDeviceProductCodeList = exports.regularByDeviceProductCodeList = {
  temperatureSensor: /^(E03|E05)/,
  smartValve: /^(E02|P0101|E12)/,
  smartValveFlush: /^P0101/,
  energyValve: /^(E09)/,
  pump: /^(E07)/
};
const regularsByDisplayNameId = exports.regularsByDisplayNameId = {
  temperatureRegex: /10[1-3]01[0-9][0-9]/i,
  durationRegex: /9990502/i,
  heatingEnergyRegex: /10[1-3]10[0-9][0-9]/i,
  flowRegex: /10205[0-9][0-9]/i,
  setPointRegex: /9030100/i,
  maxSetPointRegex: /90[3,4]0102/i,
  currentValueRegex: /9030201|9040500/gi,
  warningRegex: /9019000|904900[1-4]/gi,
  alarmRegex: /90[0-9]9100/i,
  errorRegex: /90[1,3]9200|902920[1-2]/gi,
  faultRegex: /90[0-9]9300/i,
  gearDisengagedRegex: /9039201/i,
  actuatorCannotMoveRegex: /9039202/i,
  displayNameIdColumn: /^[1-2][0-9]+/i,
  temperatureFlowRegex: /10[1-3]01(04|08|11)/i,
  temperatureReturnRegex: /10[1-3]01(05|09|12)/i,
  deltaTRegex: /10[1-3]02[0-9][0-9]/i,
  flowValveRegex: /10[1-3]05[0-9][0-9]/i,
  powerRegex: /10[1-3]09[0-9][0-9]/i,
  deviceInfoRegex: /^9\d+/i,
  pump: {
    setPoint: /9040100/i,
    currentValue: /90405[0-9][0-9]/i
  },
  smartValve: {
    setPoint: /9030100/i,
    currentValue: /90302[0-9][0-9]/i
  },
  energyValve: {
    setPoint: /9030100/i,
    currentValue: /90302[0-9][0-9]/i
  },
  error: {
    warningRegex: /9019000|904900[1-4]/gi,
    alarmRegex: /90[0-9]9100/i,
    errorRegex: /90[1,3]9200|902920[1-2]/gi,
    faultRegex: /90[0-9]9300/i,
    gearDisengagedRegex: /9039201/i,
    actuatorCannotMoveRegex: /9039202/i
  }
};
const paramsByDisplayNameId = exports.paramsByDisplayNameId = {
  controlMode: 9990102,
  pMax: 9990116,
  vMin: 9990117,
  vMax: 9990118
};
const valueType = exports.valueType = {
  float: 'float',
  int: 'int',
  bool: 'bool'
};
const ComponentTypes = exports.ComponentTypes = {
  HtgSys: 'HtgSys',
  HtgSub: 'HtgSub',
  HtgHs: 'HtgHs',
  HtgHx: 'HtgHx',
  HtgPipe: 'HtgPipe',
  HtgCc: 'HtgCc',
  PwhSupply: 'PwhSupply',
  PwhC: 'PwhC',
  PwhPipe: 'PwhPipe',
  PwcPipe: 'PwcPipe',
  PwcPoe: 'PwcPoe',
  Building: 'Building',
  EdgeNode: 'EdgeNode'
};
const LinkTo = exports.LinkTo = {
  HtgSys: 'htgSys',
  HtgHs: 'htgHs',
  HtgHx: 'htgHx',
  HtgPipe: 'htgPipe',
  HtgCc: 'htgCc',
  PwhSupply: 'pwhSupply',
  PwhC: 'pwhC',
  PwhPipe: 'pwhPipe',
  PwcPipe: 'pwcPipe',
  PwcPoe: 'pwcPoe',
  Building: 'building'
};
const SectionTypes = exports.SectionTypes = {
  flow: 2,
  return: 3,
  circulation: 4,
  none: 1
};
const LoopType = exports.LoopType = {
  primary: 2,
  secondary: 3,
  none: 1
};

/**
 * For error boundary
 * @type {{critical: string, warning: string, info: string}}
 */
const errorType = exports.errorType = {
  info: 'info',
  warning: 'warning',
  critical: 'critical'
};
const errorComponent = exports.errorComponent = {
  [errorType.info]: {
    type: errorType.info,
    title: '--',
    text: '--'
  },
  [errorType.warning]: {
    type: errorType.warning,
    title: '--',
    text: '--'
  },
  [errorType.critical]: {
    type: errorType.critical,
    title: 'Oops.',
    text: 'There has been an error somewhere, please contact technical support.'
  }
};
const millisecondsAmountInOneSecond = exports.millisecondsAmountInOneSecond = 1000;
const secondsAmountInOneMinute = exports.secondsAmountInOneMinute = 60;

/** @todo: colors object should be deleted after installing MUI Theme and refactoring components to use theme colors */
const colors = exports.colors = {
  'main-color-cl-01': '#00205B',
  'main-color-cl-02': '#000033',
  'main-color-cl-03': '#000066',
  'main-color-cl-04': '#000099',
  'main-color-cl-05': '#0000CC',
  'main-color-cl-06': '#3333FF',
  'main-color-cl-07': '#F6F8FC',
  'main-color-cl-10': '#101828',
  'main-color-cl-11': '#1D2939',
  'main-color-cl-12': '#344054',
  'main-color-cl-13': '#475467',
  'main-color-cl-14': '#667085',
  'main-color-cl-15': '#98A2B3',
  'main-color-cl-16': '#D0D5DD',
  'main-color-cl-17': '#E4E7EC',
  'main-color-cl-18': '#F2F4F7',
  'main-color-cl-19': '#FCFCFD',
  'main-color-cl-20': '#1CE783',
  'main-color-cl-21': '#FF201C',
  'main-color-cl-22': '#FF9B05',
  'main-color-cl-30': '#0000FF',
  'main-color-cl-31': '#1CE783',
  // the same as main-color-cl-20
  'main-color-cl-32': '#EFEFED',
  'main-color-cl-90': 'rgba(255, 0, 255, 0.3)',
  'main-color-cl-91': '#FF00FF',
  // missing in mockup
  'main-color-cl-01-hover': '#002B7A',
  'main-color-cl-08': '#FFFFFF',
  'main-color-cl-09': '#F3F3F3',
  'main-color-cl-40': '#E5E5E7',
  'main-color-cl-92': '#FCFCFD',
  'main-color-cl-93': '#FF8000',
  'main-color-cl-94': '#E71D1C',
  'main-color-cl-95': '#101828',
  'main-color-cl-96': '#000033',
  'main-color-cl-97': '#000066',
  'main-color-cl-98': '#475467',
  'main-color-cl-99': '#667085',
  'main-color-cl-100': '#98a2b3'
};

/** @todo: borderRadius object should be deleted after installing MUI Theme and refactoring components to use theme */
const borderRadius = exports.borderRadius = {
  button: '8px',
  input: '8px',
  card: '10px'
};

/** @todo: boxShadow object should be deleted after installing MUI Theme and refactoring components to use theme */
const boxShadow = exports.boxShadow = {
  primary: '0 5px 15px rgb(0 0 0 / 10%)',
  secondary: '0 4px 10px rgba(0, 0, 0, 0.08)'
};

/**
 @todo: styles object should be deleted after installing MUI Theme and refactoring components to use theme colors
 **/
const styles = exports.styles = {
  transitionType: {
    primary: '.5s ease',
    secondary: '.2s ease'
  },
  boxShadow: {
    primary: '0 5px 15px rgb(0 0 0 / 10%)',
    secondary: '0 4px 10px rgba(0, 0, 0, 0.08)'
  },
  borderRadius: {
    button: '8px',
    input: '8px',
    card: '10px'
  },
  textCrop: function textCrop() {
    let lines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return {
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: lines
    };
  }
};

/**
 * For toast alerts
 * @type {{error: string, success: string}}
 */
const alertTypes = exports.alertTypes = {
  error: 'error',
  success: 'success'
};